import { z } from 'zod';

export const portfolioQuickFilterSearchSchema = z.object({
  needsTeamOrEstimate: z
    .object({
      value: z.boolean().optional(),
    })
    .optional(),
});
